/**
 * Booking-service payment methods — `PaymentMethod` in the swagger.
 *
 * A different, sparse enum from the order API's `paymentType`: `[0,1,2,3,4,10,
 * 11,12,13,14,15,19]`. Everything at or above 10 was collected outside the
 * platform, which is why only those can be hand-recorded.
 */
export const PAYMENT_METHOD: Record<number, string> = {
  1: 'events.paymentMethod.card',
  2: 'events.paymentMethod.paypal',
  3: 'events.paymentMethod.placetopay',
  4: 'events.paymentMethod.athMovil',
  10: 'events.paymentMethod.cash',
  11: 'events.paymentMethod.athMovilManual',
  12: 'events.paymentMethod.bankTransfer',
  13: 'events.paymentMethod.check',
  14: 'events.paymentMethod.externalTerminal',
  // Sent straight to the business's PayPal account, not paid through the site.
  15: 'events.paymentMethod.paypalInvoice',
  19: 'events.paymentMethod.otherOffline',
};

/**
 * Only these may be recorded by hand. Mirrors `PaymentMethodExtensions`.
 * Ordered for the picker, not numerically: the manual PayPal sits beside the
 * manual ATH Movil.
 */
export const OFFLINE_PAYMENT_METHODS = [10, 11, 15, 12, 13, 14, 19];

/** Cash — the overwhelming majority of hand-recorded payments. */
export const DEFAULT_OFFLINE_METHOD = 10;

export function paymentMethodLabelKey(method: number | null | undefined) {
  if (method === null || method === undefined) {
    return 'events.paymentMethod.unknown';
  }
  return PAYMENT_METHOD[method] ?? 'events.paymentMethod.unknown';
}
